import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserService, AdminService } from 'src/app/core';
import { AddTaskComponent } from './add-task/add-task.component';
import { DeleteTaskComponent } from './delete-task/delete-task.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IsLoadingService } from '@service-work/is-loading';

@Component({
  selector: 'app-admin-tasks',
  templateUrl: './admin-tasks.component.html',
  styleUrls: ['./admin-tasks.component.scss'],
})
export class AdminTasksComponent {
  tasks: Array<any> = [];
  public dialogConfig: MatDialogConfig = {
    width: '60%',
    height: '100%',
    maxWidth: 600,
    minWidth: 400,
    maxHeight: 400,
  };
  
  getAllTasks() {
    this.isLoadingService.add();
    this.adminService.getAdminTasks().subscribe({
      next: (res: any) => {
        this.tasks = res;
      },
    }).add(() => {
      this.isLoadingService.remove();
    });
  }

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private isLoadingService: IsLoadingService,
  ) {
    this.getAllTasks();
  }

  addNewTask() {
    this.dialog
      .open(AddTaskComponent, {
        ...this.dialogConfig,
        data: {
          editMode: false,
        },
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.getAllTasks();
      });
  }

  editTask(task: any) {
    this.dialog
      .open(AddTaskComponent, {
        ...this.dialogConfig,
        data: {
          task: task,
          editMode: true,
        },
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.getAllTasks();
      });
  }

  deleteTask(task: any) {
    this.dialog
      .open(DeleteTaskComponent)
      .afterClosed()
      .subscribe((res: string | null) => {
        if (res === 'delete') {
          this.isLoadingService.add();
          this.adminService
            .deleteTask(task?.id.toString())
            .subscribe((res: any) => {
              if (res) {
                this.getAllTasks();
                this.snackBar.open('امتیاز با موفقیت حذف شد.', '', {
                  duration: 1000,
                });
              }
            }).add(() => {
              this.isLoadingService.remove();
            });;
        }
      });
  }
}
